export function getTrafficSignalState() {
  return {
    trafficSignalOptions: {},
    trafficLights: [],
    trafficSignals: [],
    trafficSignalTemplates: [],
  };
}
export default getTrafficSignalState();
